export function removeEmpty(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
}

export function sortObjectByKeyDescNumeric(obj) {
  return Object.fromEntries(
    Object.entries(obj).sort((a, b) => Number(b[0]) - Number(a[0]))
  );
}


export function sliceObject(myObject, start, end) {
  let result = {};
  const myObjLength = Object.keys(myObject).length;
  const endConditional = myObjLength < end ? myObjLength : end;

  const sliced = Object.keys(myObject).reverse().slice(start, endConditional);

  const filtered = Object.keys(myObject).filter(function (el) {
    return !sliced.includes(el);
  });

  filtered.forEach(key => {
    result[key] = myObject[key];
  });

  return result;
}

export function transformedData(data) {
  return Object.entries(data).map(([key, value]) => ({ [key]: value }));
}

export function isObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}


export function normalizeMultiplierHistory(src) {
  // izlaz: [{ mt, bonus, key }, ...]  // oldest → newest
  const out = [];
  if (!src) return out;

  if (Array.isArray(src)) {
    // stari format: [{710148:{...}}, {710147:{...}}, ...] – ostavi postojeći redosled
    for (const item of src) {
      const [k, v] = Object.entries(item)[0] || [];
      if (k && v) out.push({ ...v, key: k });
    }
  } else if (typeof src === 'object') {
    // novi format: {710148:{...}, 710147:{...}, ...}
    const keysAsc = Object.keys(src).sort((a,b) => Number(a) - Number(b)); // ASC = oldest → newest
    for (const k of keysAsc) out.push({ ...src[k], key: k });
  }
  return out;
}

export function trimHistoryToLimit(descObj, limit) {
  // descObj: objekat već sortiran DESC po ključu (rundu)
  const keys = Object.keys(descObj);
  const keep = keys.slice(0, limit);             // zadrži najnovijih N
  return Object.fromEntries(keep.map(k => [k, descObj[k]]));
}